import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Detail, Input, Select, Optional } from 'components/common';

const Container = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  > div {
    flex: 1;
  }
`;

function TradeshowLocation({
  tradeshows,
  onTradeshowChange,
  tradeshow,
  location,
  onLocationChange,
  loading,
  style,
  showLocationInput,
}) {
  const options = useMemo(
    () =>
      tradeshows.map(t => ({
        label: t.name,
        value: t.id,
      })),
    [tradeshows]
  );

  return (
    <Container style={style}>
      <Detail
        label={
          <div>
            Tradeshow <span style={{ color: 'red' }}>*</span>
          </div>
        }
        style={{ marginBottom: '8px' }}
      >
        <Select
          getPopupContainer={triggerNode => triggerNode.parentNode}
          value={tradeshow}
          size='middle'
          options={options}
          onChange={onTradeshowChange}
          style={{ width: '100%' }}
          placement='bottomRight'
          filterOption={(input, option) =>
            option.label.toLowerCase().indexOf(input?.toLowerCase()) >= 0
          }
          showSearch
          disabled={loading}
        />
      </Detail>
      {showLocationInput && (
        <Detail
          label={
            <>
              Exact location to meet (e.g. Booth)
              <Optional />
            </>
          }
          style={{ marginBottom: '0px' }}
        >
          <Input
            placeholder='Exact location to meet'
            value={location}
            onChange={onLocationChange}
            disabled={loading}
            style={{ width: '100%', resize: 'none' }}
            maxLength={50}
            multiline
            rows={1}
            showCount
          />
        </Detail>
      )}
    </Container>
  );
}

TradeshowLocation.propTypes = {
  tradeshows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  tradeshow: PropTypes.number,
  onTradeshowChange: PropTypes.func.isRequired,
  location: PropTypes.string,
  onLocationChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  style: PropTypes.shape({}),
  showLocationInput: PropTypes.bool,
};

export default TradeshowLocation;
